module.exports = __webpack_public_path__ + "img/FQES00.af1592ff.svg";